
export class OrderPayment {
    constructor({modalId, modalTriggerClass, orderAlertId}) {
        this.modal = document.getElementById(modalId);
        this.init(modalTriggerClass, orderAlertId);
    }

    async init(modalTriggerClass, orderAlertId) {
        await this.initBootstrapModal();

        this.modalTriggers = document.getElementsByClassName(modalTriggerClass);
        this.orderAlert = document.getElementById(orderAlertId);
        this.body = document.querySelector('body');
        this.html = document.querySelector('html');

        this.listen();
    }

    async initBootstrapModal() {
        if (this.modal) {
            let {default: Modal} = await import('bootstrap/js/dist/modal');
            this.modalContent = this.modal.querySelector('.modal-content');
            this.modalPlaceholder = this.modal.getAttribute('data-placeholder');
            this.bootstrapModal = new Modal(this.modal, {});
        }
    }

    listen() {
        const thisClass = this;

        Array.from(this.modalTriggers).forEach(function (button) {
            button.style.display = 'inline-block';
            button.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                thisClass.bootstrapModal.show();

                const href = button.getAttribute('href');

                thisClass.getData(href)
                    .then((data) => {
                        thisClass.redraw(data);
                    });
            });
        });

        this.modal?.addEventListener('hidden.bs.modal', function (event) {
            thisClass.modalContent.innerHTML = '<div class="modal-body">' + thisClass.modalPlaceholder + ' </div>';
        })
    }

    getData(url) {
        return fetch(url)
            .then(data => {
                return data.json();
            }).then().catch(error => {
            });
    }

    redraw(data) {
        const thisClass = this;
        if (data.form) {
            this.modalContent.innerHTML = data.form;

            if (data.type === 'gpWebPay') {
                const gpWebPaySubmit = document.getElementById('gpWebPaySubmit');
                gpWebPaySubmit?.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    document.getElementById('gpwebpayform').submit();
                });
            }

            if (data.type === 'payPalPlus') {
                const id = 'paypalplus-script';
                let script = document.getElementById(id);
                if (!script) {
                    script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.id = id;
                    script.src = 'https://www.paypalobjects.com/webstatic/ppplus/ppplus.min.js';
                    
                    script?.addEventListener('load', () => {
                        const frag = document.createRange().createContextualFragment(data.js)
                        document.body.appendChild(frag);
                    });
                    document.head.appendChild(script);
                } else {
                    const frag = document.createRange().createContextualFragment(data.js)
                    document.body.appendChild( frag );
                }
            }
        } else if (data.type === 'gpWebPayLightbox') {
            try {
                thisClass.bootstrapModal.hide()
                gpwebpay.lightbox.createGpLightBox({paymentGatewayUrl: data.link})
            } catch (e) {
                console.error('GPWebpay modal error: ', e)
            }
        } else {
            this.orderAlert.innerHTML = data.error;
            this.orderAlert.classList.add('alert-danger');
            this.orderAlert.classList.remove('d-none');
            this.bootstrapModal.hide();
        }
    }

    async initPaypalScript() {
        const id = 'paypalplus-script';
        let script = document.getElementById(id);
        if (!script) {
            script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = id;
            script.src = 'https://www.paypalobjects.com/webstatic/ppplus/ppplus.min.js';
            document.head.appendChild(script);
            script?.addEventListener('load', () => {
                
            })
        } else {
            return true
        }
    }

}
